import * as React from 'react';

function SvgCopy(props) {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 7.5H8a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h6a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5zM8 6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V8a2 2 0 00-2-2H8z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 6A2.75 2.75 0 016 3.25h6a.75.75 0 010 1.5H6c-.69 0-1.25.56-1.25 1.25v6a.75.75 0 01-1.5 0V6z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgCopy;
